(function () {
  function initSecurityRatingsTabs(root) {
    var tabs = root.querySelectorAll('[data-sr-tab]');
    if (!tabs.length) return;
 
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-sr-target');
        var target = root.querySelector('#' + targetId);
 
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('.security-ratings-tabs__panel').forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        });
 
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        if (target) {
          target.classList.add('is-active');
          target.removeAttribute('hidden');
        }
      });
    });
  }
 
  function init() {
    document.querySelectorAll('.security-ratings-tabs').forEach(initSecurityRatingsTabs);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Re-init if the section is added/edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.security-ratings-tabs');
    if (root) initSecurityRatingsTabs(root);
  });
})();